import { FC } from "react";
import { Link } from "react-router-dom";

const aboutImage =
  "https://bcrprofiles.s3.me-central-1.amazonaws.com/SHARJAH+MUNICIPALITY+BUILDING%2C+UAE.jpg";

const SectionAboutPreview: FC = () => {
  return (
    <section className="py-14 sm:py-16 lg:py-24 bg-white dark:bg-neutral-900">
      <div className="container px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="text-center lg:text-left order-2 lg:order-1">
            <span className="text-xs font-semibold tracking-widest uppercase text-primary-600">
              Who We Are
            </span>
            <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold text-neutral-900 dark:text-white">
              About Us
            </h2>
            <p className="mt-4 text-sm sm:text-base text-neutral-500 dark:text-neutral-400 leading-relaxed">
              BCR Ltd. UK is a leading supplier of high-quality construction
              products in the UAE, specializing in expansion joint covers, tile
              trims, aluminum skirtings, and shadow gap profiles. With the
              largest stock in Dubai, we deliver innovative engineering
              solutions across the Middle East.
            </p>
            <p className="mt-3 text-sm sm:text-base text-neutral-500 dark:text-neutral-400 leading-relaxed">
              From landmark government buildings to luxury residential
              developments, our products are specified by engineers and
              architects who demand UK-quality standards with regional
              availability.
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
            >
              Read more
              <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="absolute -inset-3 bg-primary-500/10 rounded-3xl blur-xl" />
              <img
                src={aboutImage}
                alt="Sharjah Municipality Building — BCR project"
                className="relative w-full rounded-2xl shadow-bcr-lg object-cover aspect-[4/3]"
              />
              <div className="absolute bottom-4 left-4 right-4 sm:bottom-5 sm:left-5 sm:right-auto">
                <span className="inline-block px-3 py-1.5 text-xs font-medium rounded-full bg-white/90 text-neutral-800 shadow-sm">
                  Sharjah Municipality Building, UAE
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionAboutPreview;
